/* eslint-disable @typescript-eslint/camelcase */ 

import  { apiModel } from '../api.url'; 
 
 
const url =  apiModel.getApi( ) + '/administrador'  ;
 

const secret_key = 'fgsdf8sfg*bxdfbsd*bxfdsf2323sf**';

function getUrl(  ) { 
	return  url; 
}


function getKeyCripto(  ) { 
	return  secret_key; 
}


export const administradorModel = { 
	getUrl, 
	getKeyCripto,
};
